import * as React from 'react'
import { Spacer, spacerSpacing, spacerAlignItems } from '@amzn/dvui/dist/Spacer'
import * as st from './badgesComponent.module.scss'

import { connect } from 'react-redux'

import { IRuntimeBadgeProps, Runtime } from '../../components/badges/runtime'
import { IMaturityRatingBadgeProps, Rating } from '../../components/badges/rating'
import { IAmazonRatingBadgeProps, AmazonRating } from '../../components/badges/amazonRating'
import { IImdbScoreBadgeProps, ImdbScore } from '../../components/badges/imdbScore'
import { ISubtitlesBadgeProps, Subtitles } from '../../components/badges/subtitles'
import { IReleaseYearBadgeProps, ReleaseYear } from '../../components/badges/releaseYear'
import { ILocationBadgeProps, Location } from '../../components/badges/location'
import { IXRayBadgeProps, XRay } from '../../components/badges/xRay'
import { IDateTimeBadgeProps, DateTime } from '../../components/badges/dateTime'
import { HdrBadgeProps, Hdr } from '../../components/badges/hdr'
import { UhdBadgeProps, Uhd } from '../../components/badges/uhd'
import { AdBadgeProps, Ad } from '../../components/badges/ad'

import {
  amazonRatingSelector,
  imdbSelector,
  locationSelector,
  ratingBadgeSelector,
  releaseYearSelector,
  runtimeSelector,
  seasonsBadgeSelector,
  subtitlesSelector,
  xRaySelector,
  dateTimeBadgeSelector,
  hdrSelector,
  uhdSelector,
  adSelector
} from '../../selectors/component/badgeComponentSelectors'
import { ISeasonsBadgeProps, Seasons } from '../../components/badges/seasons'
import { IDetailPageState } from '../../reducers'


type BadgeComponentProps = {
  amazonRating?: IAmazonRatingBadgeProps
  imdb?: IImdbScoreBadgeProps
  ratingBadge?: IMaturityRatingBadgeProps
  dateTimeBadge?: IDateTimeBadgeProps
  releaseYear?: IReleaseYearBadgeProps
  runtime?: IRuntimeBadgeProps
  subtitles?: ISubtitlesBadgeProps
  location?: ILocationBadgeProps
  xRay?: IXRayBadgeProps
  hdr?: HdrBadgeProps
  uhd?: UhdBadgeProps
  ad?: AdBadgeProps
  seasons?: ISeasonsBadgeProps
}

export const BadgesComponent = ({
  amazonRating,
  imdb,
  ratingBadge,
  dateTimeBadge,
  releaseYear,
  runtime,
  subtitles,
  location,
  xRay,
  hdr,
  uhd,
  seasons,
  ad
}: BadgeComponentProps) => (
  <Spacer className={`dv-node-dp-badges ${st.badges}`}
          space={spacerSpacing.s} alignItems={spacerAlignItems.center}>
    {amazonRating && <AmazonRating {...amazonRating} />}
    <DateTime {...dateTimeBadge}/>
    <Location {...location} />
    <ImdbScore {...imdb} />
    <Runtime {...runtime}/>
    <ReleaseYear {...releaseYear}/>
    {seasons && <Seasons {...seasons} />}
    <XRay {...xRay} />
    <Hdr {...hdr}/>
    <Uhd {...uhd}/>
    <Ad {...ad}/>
    <Rating {...ratingBadge} />
    <Subtitles {...subtitles} />
  </Spacer>
)

const mapStateToProps = (state: IDetailPageState): BadgeComponentProps => {
  return {
    amazonRating: amazonRatingSelector(state),
    imdb: imdbSelector(state),
    ratingBadge: ratingBadgeSelector(state),
    dateTimeBadge: dateTimeBadgeSelector(state),
    releaseYear: releaseYearSelector(state),
    runtime: runtimeSelector(state),
    subtitles: subtitlesSelector(state),
    location: locationSelector(state),
    xRay: xRaySelector(state),
    hdr: hdrSelector(state),
    uhd: uhdSelector(state),
    ad: adSelector(state),
    seasons: seasonsBadgeSelector(state)
  }
}


export const Badges = connect(mapStateToProps)(BadgesComponent)
